export const isPageActive = (endpointToSearch: string): boolean => {
  const pathname = window.location.pathname;

  const isActive = pathname.includes(endpointToSearch);
  return isActive;
};
